import React from 'react';
import styled from 'styled-components';

const EarnedIncomeCredit = () => {
    return (
        <EarnedIncomeCreditStyled className='EarnedIncomeCredit'>
            <h3><strong>2022 Earned Income Tax Credit</strong></h3>
            <div className="table-responsive-sm">
                <table className='table table-bordered'>
                    <thead>
                        <tr>
                            <th>Filing Status</th>
                            <th>Number of Children</th>
                            <th>Maximum Credit</th>
                            <th>Phaseout Begins</th>
                            <th>Phaseout Ends</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td rowSpan={5}>Single or Head of Household</td>
                        </tr>
                        <tr>
                            <td>0</td>
                            <td>$560</td>
                            <td>$9,160</td>
                            <td>$16,480</td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>$3,733</td>
                            <td>$20,130</td>
                            <td>$43,492</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>$6,164</td>
                            <td>$20,130</td>
                            <td>$49,399</td>
                        </tr>
                        <tr>
                            <td>3 or More</td>
                            <td>$6,935</td>
                            <td>$20,130</td>
                            <td>$53,057</td>
                        </tr>
                        <tr><td colSpan={5} className="emptyRow"/></tr>
                        <tr>
                            <td rowSpan={5}>Married Filing Joint</td>
                        </tr>
                        <tr>
                            <td>0</td>
                            <td>$560</td>
                            <td>$15,920</td>
                            <td>$22,610</td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>$3,733</td>
                            <td>$26,260</td>
                            <td>$49,622</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>$6,164</td>
                            <td>$26,260</td>
                            <td>$55,529</td>
                        </tr>
                        <tr>
                            <td>3 or More</td>
                            <td>$6,935</td>
                            <td>$26,260</td>
                            <td>$59,187</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </EarnedIncomeCreditStyled>
    );
}

export default EarnedIncomeCredit;

const EarnedIncomeCreditStyled = styled.div`
    margin-bottom: 15px;
    table {
        thead {
            tr {
                border-bottom: 1px solid #ddd;
            }
            th {
                border-right: 1px solid #ddd;
                :last-child {
                    border-right: none;
                }
            }
        }
        tbody {
            tr {
                border-bottom: 1px solid #ddd;
                :last-child {
                    border-bottom: none;
                }
            }
            td {
                border-right: 1px solid #ddd;
                :nth-child(n + 4){
                    border-right: none;
                }
            }
            .emptyRow {
                border-right: none;
            }
        }
    }

`;